import React from "react";
import { Box, Container } from "@mui/material";
import {
  HeroSection,
  ProfileSection,
  SkillsSection,
  ExperienceSection,
  EducationSection,
  InterestsSection,
  CTASection,
} from "../components/about";

function About() {
  return (
    <Box>
      <HeroSection />

      <Container sx={{ py: 6 }}>
        <ProfileSection />
        <SkillsSection />
        <ExperienceSection />
        <EducationSection />
        <InterestsSection />
        <CTASection />
      </Container>
    </Box>
  );
}

export default About;
